import ValidatEmail from "../../../../pages/Auth/ValidatEmail";
import Tracking from "../../../../pages/Home/Tracking";
import TrackingNew from "../../../../pages/Home/sharedtracking";

const routesPublic = [
    {
        key: "validate",
        path: "/validate-email",
        element: <ValidatEmail />,
    },
    {
        key: "tracking",
        path: "/tracking/:id",
        element: <TrackingNew isPublic />,
    },
]

export default routesPublic